import { RotateCcw } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { NavLink, useLocation } from 'react-router-dom'

import { Button } from '@/components/ui/button'
import { useWorkbenchStore } from '@/stores/workbench.store'

import { DesktopTabs } from './DesktopTabs'
import { LanguageToggle } from './LanguageToggle'
import { MobileMenuSheet } from './MobileMenuSheet'
import { UserMenu } from './UserMenu'

export const TopBar = () => {
  const { t } = useTranslation('common')
  const location = useLocation()
  const resetWorkbench = useWorkbenchStore((state) => state.reset)
  const showWorkbenchReset = location.pathname === '/workbench'

  return (
    <header className="flex h-14 shrink-0 items-center gap-4 border-b border-border bg-[hsl(var(--topbar))] px-4 lg:px-8">
      <NavLink to="/workbench" className="flex items-center">
        <img
          className="h-8 w-auto"
          src="https://cdn.myxypt.com/24c34402/24/06/1952343aebd2fe64060ee142ac7a6dc64810a6f4.png"
          alt={t('app_name')}
        />
      </NavLink>
      <DesktopTabs className="hidden flex-1 lg:flex" />
      <div className="ml-auto hidden items-center gap-3 lg:flex">
        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          {/* <span className="h-2 w-2 rounded-full bg-success" /> */}
          {/* <span>{t('synced')}</span> */}
        </div>
        <LanguageToggle />
        <UserMenu />
      </div>
      <div className="ml-auto flex items-center gap-2 lg:hidden">
        <LanguageToggle />
        {showWorkbenchReset ? (
          <Button variant="ghost" size="icon" aria-label={t('actions.reset_workbench')} onClick={resetWorkbench}>
            <RotateCcw className="h-5 w-5" aria-hidden="true" strokeWidth={1.5} />
          </Button>
        ) : null}
        <MobileMenuSheet />
      </div>
    </header>
  )
}
